import styled from 'styled-components';

import Button from '~/src/common/components/Button';
import { media } from '~/src/styles-constants';

export const IMAGE_SIZE_SMALL = 280;
export const IMAGE_SIZE_LARGE = 369;
const IMAGE_GAP = 16;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  margin-top: 16px;

  ${media.M`
    margin-top: 8px;
  `}
`;

export const Container = styled.div`
  align-self: flex-start;
  width: 100%;
  position: relative;
  overflow: hidden;
`;

export const ImagesWrapper = styled.div<{ $translateX: number; $withNavigation: boolean }>`
  display: flex;
  align-items: center;
  gap: ${IMAGE_GAP}px;

  width: inherit;

  transition-duration: 0.5s;

  height: ${IMAGE_SIZE_SMALL}px;
  transform: translateX(${({ $translateX }) => $translateX * -(IMAGE_SIZE_SMALL + IMAGE_GAP)}px);
  ${media.L<{ $translateX: number }>`
    height: ${IMAGE_SIZE_LARGE}px;
    transform: translateX(${({ $translateX }) => $translateX * -(IMAGE_SIZE_LARGE + IMAGE_GAP)}px);
  `}
`;

export const ImageWrapper = styled.div<{ $index: number; $ratio: number; $offsetX: number }>`
  flex-shrink: 0;
  position: absolute;
  border-radius: 8px;
  background: ${({ theme }) => theme.palette.common.PLACEHOLDER};

  height: ${IMAGE_SIZE_SMALL}px;
  width: ${IMAGE_SIZE_SMALL}px;
  transform: translateX(${({ $index, $offsetX }) => $index * (IMAGE_SIZE_SMALL + 16) + $offsetX}px);
  ${media.L<{ $index: number }>`
    height: ${IMAGE_SIZE_LARGE}px;
    width: ${IMAGE_SIZE_LARGE}px;
    transform: translateX(${({ $index }) => $index * (IMAGE_SIZE_LARGE + 16)}px);
  `}

  &:hover > div:last-child {
    display: flex;
  }
`;

export const Image = styled.img`
  border-radius: inherit;
  object-fit: cover;
  cursor: zoom-in;

  height: ${IMAGE_SIZE_SMALL}px;
  width: ${IMAGE_SIZE_SMALL}px;
  ${media.L`
    height: ${IMAGE_SIZE_LARGE}px;
    width: ${IMAGE_SIZE_LARGE}px;
  `}
`;

export const ThumbnailsContainer = styled.div`
  display: none;
  flex-direction: column;
  gap: 16px;
  flex-shrink: 0;

  ${media.S`
    display: flex;
  `}
`;

export const ThumbnailImage = styled.img<{ $isActive: boolean }>`
  height: 80px;
  width: 80px;
  border: ${({ $isActive, theme }) =>
    $isActive ? `solid 2px ${theme.palette.common.PRIMARY}` : 'none'};
  border-radius: 8px;
  cursor: pointer;
`;

export const CarouselArrow = styled(Button)<{ $direction: string }>`
  display: none;
  opacity: 0;

  position: absolute;

  /* 24px: La moitié de la hauteur du composant (48px) - 15px: La moitié du décalage de ImageWrapper (30px) */
  top: calc(50% - 39px);
  right: ${({ $direction }) => ($direction === 'right' ? '8px' : 'auto')};
  left: ${({ $direction }) => ($direction === 'left' ? '8px' : 'auto')};

  min-width: 48px;
  height: 48px;
  margin: 0;

  border: none;
  transition: opacity 0.3s ease-in-out;

  ${Container}:hover & {
    opacity: 1;
  }

  ${media.M`
    display: block;
  `}
`;

export const EyeIconWrapper = styled.div`
  position: absolute;
  top: calc(50% - 20px);
  left: calc(50% - 20px);
  pointer-events: none;

  /* Surchargé par la div wrapper */
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 1;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.palette.common.WHITE};
`;
